import singleSpaHtml from "single-spa-html";
import * as DOMPurify from "dompurify";

const htmlLifecycles = singleSpaHtml({
  template: () => {
    const urlParams = new URLSearchParams(window.location.search);
    const requestedUrl = DOMPurify.sanitize(urlParams.get("requestedUrl") || "", { ALLOWED_TAGS: ["#text"] });
    return `
    <style>
    #page-404-container {
      font-family: Roboto, sans-serif;
      color: rgba(0,0,0,.87);
      display: flex;
      height: calc(100vh - 75px);
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    
    #page-404-container h1 {
      font-size: 100px;
      letter-spacing: 0.5rem;
    }

    #page-404-container p {
      margin-top: 40px;
      font-size: 24px;
      color: #616161;        
    }

    #back-home-button {
      margin-top: 40px;
      background-color: #1976d2;
      color: white;
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
      padding: 10px 24px;
      border-radius: 4px;
      text-decoration: none;
      font-weight: 500;
      font-size: 14px;
    }
    </style>
    <div id="page-404-container">
      <p>NOT FOUND</p>
      <h1>404</h1>
      <p>Sorry, we couldn't find the requested URL.</p>
      <p>${requestedUrl}</p>
      <a href="/" id="back-home-button">BACK TO HOME</a>
    </div>
    `;
  },
});

export const { bootstrap } = htmlLifecycles;
export const { mount } = htmlLifecycles;
export const { unmount } = htmlLifecycles;